<template>
    <div class="w-full flex flex-row px-3 py-2 cursor-pointer border-100 border-bottom-1" @click="openPopup" style="min-height:50px">
        <div class="flex mr-3 align-items-center">
            <Avatar class="text-600" size="small" icon="pi pi-phone" shape="circle"/>
        </div>
        <div class="flex flex-1 justify-content-left align-items-center">
            <span class="text-600">+{{ prefix }}{{ phone }}</span>
        </div>
        <div class="flex justify-content-right align-items-center">
            <span v-if="!phone" class="text-sm text-blue-500">{{ lang('button_set') }}</span>
            <i class="text-blue-500 ml-2" :class="'pi pi-angle-right'" />
        </div>
    </div>
    
    <Dialog class="w-full surface-100 border-none" modal @hide="setUpDefault"
        v-model:visible="popup" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ lang('phone_link_title') }}</span>
        </template>

        <div class="w-full flex h-full flex-column gap-2">
            <span class="text-sm text-600">{{ lang('phone')}}:</span>
            <div class="p-inputgroup w-full flex flex-row gap-0">

                <!--COUNTRIES-->
                <span class="flex p-inputgroup-addon p-0 border-2 border-round-left-xl border-noround-right border-right-none surface-border">
                    <Dropdown v-model="selectedCountry" :options="countries" filter optionLabel="name" :placeholder="lang('choose_country')"
                        class="border-none flex w-8rem justify-content-left align-items-center border-round-left-xl border-noround-right">
                        <template #value="slotProps">
                            <div v-if="slotProps.value" class="flex max-w-6rem align-items-center">
                                <img :alt="slotProps.value.label" src="/images/flags/flag_placeholder.png" :class="`mr-2 flag flag-${slotProps.value.code.toLowerCase()}`" style="width: 18px" />
                                <div>{{ slotProps.value.first }}</div>
                            </div>
                            <span v-else>
                                {{ slotProps.placeholder }}
                            </span>
                        </template>
                        <template #option="slotProps">
                            <div class="flex max-w-6rem align-items-center">
                                <img :alt="slotProps.option.label" src="/images/flags/flag_placeholder.png" :class="`mr-2 flag flag-${slotProps.option.code.toLowerCase()}`" style="width: 18px" />
                                <div>{{ slotProps.option.name }} {{ slotProps.option.first }}</div>
                            </div>
                        </template>
                    </Dropdown>
                </span>

                <!--PHONE-->
                <div class="w-full p-inputgroup-addon p-input-icon-right flex flex-1 p-0 border-none">
                    <IconField iconPosition="right" class="w-full">
                        <InputIcon class="pi pi-phone pl-1"/>

                        <InputNumber input-id="phone" v-model="phone" :placeholder="get_mask(phone_mask_arr[0])" aria-labelledby="phone" aria-describedby="phone-help" :useGrouping="false"
                            :class="((phone && getLength(phone)) && !isValid) ? 'p-invalid border-red-400' : 'border-400'" 
                            class="w-full flex border-2 border-round-right-xl border-noround-left overflow-hidden" size="large"/>

                        <InputIcon class="pi pi-times pr-1 cursor-pointer" @click="clear()"/>
                    </IconField>
                </div>
            </div>
            <div class="w-full h-2rem">
                <small v-if="!isValid" class="text-red-500">
                    {{ content[lang_].invalid }}
                </small>
            </div>
        </div>

         <template #footer>
            <div class="w-full flex flex-row gap-3">
                <Button type="submit" class="w-full border-round-lg" @click="updateUser()"
                    :label="lang('button_save')" :loading="loading" :disabled="!isValid || loading" size="large"/>
            </div>
        </template>
    </Dialog>
</template>

<script>
import Connect from             '@/assets/js/Connect.js'
import { mapActions } from      "vuex"
import { useVuelidate } from    "@vuelidate/core"
import MobMenu from             '@/components/sides/menu/MobMenu.vue' 
import { email, required, sameAs, minLength, maxLength } from "@vuelidate/validators";

export default {
    data(){
        return {
            loading: false,
            phone: null,
            prefix: null,
            phone_mask_arr: [],
            isValid: true,
            popup: false,
            v$: useVuelidate(),
            countries: [],
            selectedCountry: null,
            ready: false,

            content: {
                ru: {
                    invalid: 'Неверный номер телефона',
                    mess_success: 'Успешно',
                    mess_success_text: 'Профиль успешно обновлен',
                    mess_error: 'Ошибка',
                    mess_error_text: 'Ошибка при обновлении профиля',
                    already_exists: 'Пользователь с таким номером уже существует',
                },
                en: {
                    invalid: 'Invalid phone number',
                    mess_success: 'Success',
                    mess_success_text: 'Profile updated successfully',
                    mess_error: 'Error',
                    mess_error_text: 'Profile update error',
                    already_exists: 'A user with this phone number already exists',
                }
            }
        }
    },
    validations() {
        return {
            phone: {
                required
            },
        }
    },
    components: {
        MobMenu
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    watch: {
        phone: function(val){
            if(!this.ready) return
            if(!val) {
                this.isValid = false
                return
            }
            const phoneFormat = val.toString()
            if(!phoneFormat) {
                this.isValid = false
                return
            }

            // если масок нет, то валидируем по длине
            if(!this.phone_mask_arr || this.phone_mask_arr.length == 0){
                if(phoneFormat.length >= 11 && phoneFormat.length <= 18){
                    this.isValid = true
                } else {
                    this.isValid = false
                }
                return
            } 
            // если маска одна, то валидируем по совпадению длины маски и значения
            if(this.phone_mask_arr.length == 1){
                const maskFormat = this.phone_mask_arr[0].replaceAll('\-', '').replaceAll('\(', '').replaceAll('\)', '').replaceAll('\ ', '')
                if(phoneFormat.length == maskFormat.length){
                    this.isValid = true
                } else {
                    this.isValid = false
                }
                return
            }else{
                // если масок несколько, то валидируем по совпадению длины маски и значения
                let minLength = 1000
                let maxLength = 0
                // находим самую длинную и короткую 
                for(let i=0; i<this.phone_mask_arr.length; i++){
                    let mask = this.phone_mask_arr[i]
                    let maskFormat = mask.replaceAll('\-', '').replaceAll('\(', '').replaceAll('\)', '').replaceAll('\ ', '')
                    if(maskFormat.length < minLength){
                        minLength = maskFormat.length
                    }
                    if(maskFormat.length > maxLength){
                        maxLength = maskFormat.length
                    }                    
                }
                if(phoneFormat.length >= minLength && phoneFormat.length <= maxLength){
                    this.isValid = true
                } else {
                    this.isValid = false
                }
            }
            return
        },
        selectedCountry(){
            try{
                if(this.selectedCountry.mask && this.selectedCountry.mask.length > 0) {
                    if(typeof(this.selectedCountry.mask)=='object'){
                        this.phone_mask_arr = this.selectedCountry.mask
                    }else{
                        this.phone_mask_arr = [this.selectedCountry.mask]
                    }
                    this.prefix = this.selectedCountry.first.replace(/\D+/g,"")
                }else{
                    this.phone_mask_arr = []
                }
            } catch (error) {
                console.log('error', error)
                this.phone_mask_arr = []
            }
        }
    },
    methods:{
        lang(value){
            if(!value) return null
            if(!this.$t) return value
            return this.$t(`views.personal.profile.${value}`)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        getLength(val) {
            if (!val) return 0
            return val.toString().length
        },
        get_mask(val){
            if(!val) return ''
            return val.replaceAll('\#', '9')
        },
        openPopup(){
            this.selectedCountry = this.getCountryByCode(this.country)
            this.popup = true
        },
        setUpDefault(){
            this.phone = (this.$store.getters.StateUserPhone) ? this.$store.getters.StateUserPhone : null
            this.prefix = (this.$store.getters.StateUserPrefix) ? this.$store.getters.StateUserPrefix : null
            this.country = (this.$store.getters.StateUserCountry) ? this.$store.getters.StateUserCountry : null
            this.selectedCountry = this.getCountryByCode(this.country)
        },
        clear(){
            this.phone = null
        },
        getCountryByCode(code) {
            if (!code) return null
            if(!this.ready) return null
            if(!this.countries || this.countries.length==0) return null
            return this.countries.find(country => country.code === code) || null
        },
        async getCountries() {
            try{
                const countries = await this.connect.get_countries().then(res=>res)
                if(countries.result) {
                    this.countries = countries.data
                    for (let i = 0; i < this.countries.length; i++) {
                        const country = this.countries[i];
                        if(this.country && country.code==this.country){
                            // задаем страну
                            this.selectedCountry = country
                            this.country_display = country.name
                            this.ready = true
                            break
                        } else {
                            if(country.code=='RU'){
                                this.selectedCountry = country
                                this.country_display = country.name
                                this.ready = true
                            }
                        }
                    }
                }
            } catch (error) {
                console.log('error', error)
            }
        },
        formatErrors(errors){
            if(!errors || errors.length === 0) return ''
            const err = errors[0]
            if(err == 'This phone already exists') return this.content[this.lang_].already_exists
            else return this.content[this.lang_].mess_error_text
        },
        ...mapActions(["ActionUpdUser"]),
        async updateUser() {
            if(!this.isValid) return
            this.loading = true

            const formatedPhone = this.phone.toString()
            const formatedPrefix = this.prefix.replace(/\D+/g,"")

            let updData = {
                phone: formatedPhone,
                prefix: formatedPrefix,
                country: this.selectedCountry.code
            }

            try{
                const update = await this.ActionUpdUser(updData).then(res=>res)
                if(update.result && update.data) {
                    this.showMess('success', this.content[this.lang_].mess_success, this.content[this.lang_].mess_success_text)
                    this.loading = false
                    this.popup = false
                } else {
                    this.loading = false
                    if(update.errors) this.showMess('error', this.content[this.lang_].mess_error, this.formatErrors(update.errors))
                    else this.showMess('error', this.content[this.lang_].mess_error, this.content[this.lang_].mess_error_text)
                }
            } catch (e) {
                console.log(e)
                this.loading = false
                this.showMess('error', this.content[this.lang_].mess_error, this.content[this.lang_].mess_error_text)
            }
        },
    },
    beforeCreate(){
        this.connect = new Connect()
    },
    created() {
        this.getCountries().then()
        this.setUpDefault()
        this.v$ = useVuelidate()
    },
}
</script>